module.exports = __webpack_public_path__ + "img/ysgj_014@2x.2a28e608.png";